import { PlatformGroupsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function usePlatformGroupsAPI(): PlatformGroupsApi {
  return new PlatformGroupsApi(apiConfig);
}
